import Service from "../Service";
const resource = "PrfCustomerTemplate/";

export default {
  pagination(obj, requestID) {
    return Service.post(resource + "paginationVariant", obj, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "saveVariant", obj, {
      params: { requestID },
    });
  },
};
